<template functional>
    <div>
        <div class="lds-ripple">
            <div></div>
            <div></div>
        </div>
    </div>
</template>

<script>

export default {
    functional: true,
    name: 'SpinnerRipple',
    props: {
        
    },
}
</script>

<style>
.lds-ripple {
  display: inline-block;
  position: relative;
  width: 1rem;
  height: 1rem;
}
.lds-ripple div {
  position: absolute;
  border: 1px solid #000;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
/* the calc values should subtract relative to border width set above */
@keyframes lds-ripple {
  0% {
    top: calc(0.5rem - 1px);
    left: calc(0.5rem - 1px);
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: calc(1rem - 2px);
    height: calc(1rem - 2px);
    opacity: 0;
  }
}
</style>